import React from "react"
import { Box, Drawer } from "@mui/material"

export const drawerWidth = 240

interface Props {
  mobileOpen: boolean
  onClose: () => void
  onTransitionEnd: () => void
  children: React.ReactNode
}

const NavDrawer: React.FC<Props> = ({ mobileOpen, onClose, onTransitionEnd, children }) => (
  <Box component="nav" sx={{ width: { md: drawerWidth }, flexShrink: { sm: 0 } }}>
    <Drawer
      variant="temporary"
      open={mobileOpen}
      onTransitionEnd={onTransitionEnd}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      sx={{
        display: { xs: "block", md: "none" },
        "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth }
      }}>
      {children}
    </Drawer>
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: "none", md: "block" },
        "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth }
      }}
      open={false}>
      {children}
    </Drawer>
  </Box>
)

export default NavDrawer
